import { affordabilityEndPoints } from "@src/apps/constants/ApiMappingConstants/affordabilityEndPoints";
import { checkIsInternal } from "@src/utility/createStorage";
import httpService from "@src/utility/httpService";
import { config } from '@uhg-abyss/web/tools/config';
const _httpService = new httpService();

const apiDomainInternal = config('API_DOMAIN_INTERNAL');

_httpService.setBaseURL(apiDomainInternal);
export const getDdpData = async (payload: any) => {
    const response:any = await _httpService.push(
        '/affordability/ddp-mpin-details',
        payload
      );
    return response;
};